'use client'

import { useEffect, useState } from 'react'
import Image from 'next/image'
import { findLogoByMerchantId } from '@/utils/utils'

export type MerchantLogo = {
  [merchantId: string]: string
}

interface MerchantLogoProps {
  enableMerchantLogo: MerchantLogo[]
  merchantId: string
}

export const MerchantLogo = ({ enableMerchantLogo, merchantId }: MerchantLogoProps) => {
  const [logoImage, setLogoImage] = useState<string>('')

  useEffect(() => {
    const fetchLogoImage = () => {
      const imageFound =
        enableMerchantLogo?.length && findLogoByMerchantId(merchantId, enableMerchantLogo)
      if (imageFound) {
        setLogoImage(imageFound)
      }
    }

    fetchLogoImage()
  }, [merchantId, enableMerchantLogo])

  const displayLogo = logoImage && enableMerchantLogo?.length

  if (displayLogo) {
    return (
      <Image
        src={`${process.env.ICONS_URL}/logos/${logoImage}`}
        width={40}
        height={40}
        alt={logoImage}
        loading="lazy"
        className="bg-transparent"
      />
    )
  } else {
    return null
  }
}
